import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Tooltip } from 'antd'
import { useIsMobile } from 'hooks/useIsMobile'
import { ILearningPathCard } from 'models/learningPathCard.model'
import { LearningPathEnrollStatus } from 'enum/learningPathEnrollStatus.enum'
import {
  LearningPathCardBase,
  DefaultIcon,
  Tag,
  ProgressBar,
} from '../../atoms'
import styles from './LearningPathCardSmall.module.scss'

interface Props {
  learningPath: Pick<
    ILearningPathCard,
    'id' | 'name' | 'description' | 'pictureUrl'
  >
  enrolStatus: LearningPathEnrollStatus
  className?: string
  style?: React.CSSProperties
  progress: number
  noAvailable?: boolean
}

export const LearningPathCardSmall = ({
  learningPath,
  className,
  style,
  progress,
  enrolStatus,
  noAvailable,
}: Props) => {
  const isMobile = useIsMobile()
  const history = useHistory()

  const { t } = useTranslation()

  const openLearningPath = () => {
    if (noAvailable) return
    history.push(`/learning-path/${learningPath.id}`)
  }

  const url = learningPath.pictureUrl
  return (
    <LearningPathCardBase
      className={classNames(
        className,
        styles.card,
        noAvailable ? styles.disabled : ''
      )}
      style={style}
      onClick={() => openLearningPath()}
    >
      <div
        className={classNames(
          styles.container,
          isMobile ? styles.containerMobile : ''
        )}
      >
        <div className={styles.imageContainer}>
          {url ? (
            <div>
              <img src={url} />
            </div>
          ) : (
            <DefaultIcon className={styles.defaultIcon} />
          )}
        </div>
        <div className={styles.infoContainer}>
          <Tag
            text={t('learningPaths.cards.tags.default')}
            icon={faGraduationCap}
          />
          <div className={classNames('text-truncate', styles.title)}>
            {learningPath.name}
          </div>
          <ProgressBar progressPercentage={progress} advance={enrolStatus} />
        </div>
      </div>
      {noAvailable && (
        <Tooltip
          title={t(`learningPaths.cards.tooltips.notAvailable`)}
          placement="bottom"
        >
          <div className={styles.noAvailable} />
        </Tooltip>
      )}
    </LearningPathCardBase>
  )
}
